<template>
  <div class="organization-wrap">
    <div class="organization-box">
      <h4 class="title">Organization chart</h4>
      <ul class="badges" v-if="false">
        <li v-for="i in activeLevelColors" :key="i"><div class="square" :style="`background-color: ${colors[i]};`"></div><div class="name">{{i}}</div></li>
      </ul>
      <div class="fields">
        <div class="field">
          <div class="field-input" style="display: flex">
            <el-input placeholder="Search your friend" v-model="filterText" @keyup.enter.native="search"></el-input>
            <el-button @click="search">Search</el-button>
          </div>
        </div>
      </div>
      <div class="binary-tree-wrap" v-if="treeData.length">
        <el-tree
          ref="tree"
          :data="treeData"
          :render-content="renderContent"
          node-key="id"
          :default-expanded-keys="expandedKeys"
          :indent="indent"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :filter-node-method="filterNode"
        ></el-tree>
      </div>
    </div>
  </div>

</template>

<script>
import CONSTANT from '@/configs/constant'
export default {

  data () {
    return {
      colors: CONSTANT.COLORS_LEVEL,
      filterText: '',
      indent: window.innerWidth < 500 ? 5 : 20,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      expandedKeys: [1]
    }
  },
  computed: {
    levelColors () {
      return Object.keys(this.colors)
    },
    activeLevelColors () {
      return this.levelColors.filter(temp => temp !== 'R0')
    },
    treeData () {
      return this.$store.getters.treeData
    }
  },
  created () {
    this.$store.dispatch('setLoadChart', true)
    this.$store.dispatch('getBinaryData').finally(e => {
      this.$store.dispatch('setLoadChart', false)
    })
  },
  methods: {
    handleNodeClick () {
    },
    search () {
      this.$refs.tree.filter(this.filterText)
    },
    filterNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    getElementByRole (node, data) {
      const role = data.role
      const regex = /\(([^)]+)\)/g
      const matches = [...node.label.matchAll(regex)]
      return (<div class={`tree-node-item level-${role.toLowerCase()}`}>
        <div class="tree-node-icon">{role}</div>
        <div class="tree-node-label">{matches[0] ? matches[0][1] ?? '' : ''} ({matches[2] ? matches[2][1] ?? 0 : 0})</div>
      </div>)
      // switch (role) {
      //   case 'R0':
      //     return (
      //       <div>
      //         <span class="custom-tree-node r0">
      //           <span>{node.label}</span>
      //         </span>
      //       </div>)
      //   case 'R1':
      //     return (
      //       <div>
      //         <span class="custom-tree-node r1">
      //           <span>{node.label}</span>
      //         </span>
      //       </div>)
      //   case 'R2':
      //     return (
      //       <div>
      //         <span class="custom-tree-node r2">
      //           <span>{node.label}</span>
      //         </span>
      //       </div>)
      //   case 'R3':
      //     return (
      //       <div>
      //         <span class="custom-tree-node r3">
      //           <span>{node.label}</span>
      //         </span>
      //       </div>)
      //   case 'R4':
      //     return (
      //       <div>
      //         <span class="custom-tree-node r4">
      //           <span>{node.label}</span>
      //         </span>
      //       </div>)
      //   case 'R5':
      //     return (
      //       <div>
      //         <span class="custom-tree-node r5">
      //           <span>{node.label}</span>
      //         </span>
      //       </div>)
      //   case 'R6':
      //     return (
      //       <div>
      //         <span class="custom-tree-node r6">
      //           <span>{node.label}</span>
      //         </span>
      //       </div>)
      //   case 'R7':
      //     return (
      //       <div>
      //         <span class="custom-tree-node r7">
      //           <span>{node.label}</span>
      //         </span>
      //       </div>)
      //   case 'R8':
      //     return (
      //       <div>
      //         <span class="custom-tree-node r8">
      //           <span>{node.label}</span>
      //         </span>
      //       </div>)
      //   case 'USER':
      //     return (
      //       <div>
      //         <span class="custom-tree-node user">
      //           <span>{node.label}</span>
      //         </span>
      //       </div>)
      //   case 'STARTER':
      //     return (
      //       <div>
      //         <span class="custom-tree-node starter">
      //           <span>{node.label}</span>
      //         </span>
      //       </div>)
      //   default:
      //     return (
      //       <div>
      //         <span class="custom-tree-node user">
      //           <span>{node.label}</span>
      //         </span>
      //       </div>)
      // }
    },
    renderContent (h, { node, data, store }) {
      return this.getElementByRole(node, data)
    }
  }
}
</script>
